export default {
  geolocation: {
    lat: '37.5665',
    lng: '126.9779',
    label: '03001 Seoul',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
